import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import PrintsLoader from '../loaderComponents/PrintsLoader';
import FETCH from '../Fetch';
// import { toast } from './Notifier';

export default class Prints extends Component {
  state = {
    loading: true,
    documents: null
  };

  componentDidMount() {
    FETCH.getDocuments()
      .then(response => {
        if (response.data && typeof response.data != "string") {
          this.setState({ documents: response.data, loading: false });
        } else {
          this.setState({
            loading: false,
            message:
              response.message || 'Server could not be reached, try again later'
          });
        }
      })
      .catch(error => console.log(error));
  }

  render() {
    const { loading, documents, message } = this.state;
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1>Print Files</h1>
        {!loading && documents == null ? (
          <NoDocuments message={message} />
        ) : (
            <div className="row">
              {loading ? (
                <Fragment>
                  <PrintsLoader />
                  <PrintsLoader />
                  <PrintsLoader />
                </Fragment>
              ) : (
                  <Fragment>
                    {documents.map(item => (
                      <PrintCard key={item.name} item={item} />
                    ))}
                  </Fragment>
                )}
            </div>
          )}
      </main>
    );
  }
}

class PrintCard extends Component {
  render() {
    const { item } = this.props;
    return (
      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
        {/* card for fees */}
        <div className="card min-h-200">
          <div className="card-body print-container">
            <div className="print-session">
              {item.session ||
                `${item.category[0].toUpperCase()}${item.category.slice(1)}`}
            </div>
            <h2>{item.name}</h2>
            <div className="print-btn-container">
              <div className="row no-gutters">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <a
                    href={item.print_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-primary-color btn-remove-p-r w-100"
                  >
                    Print Document
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const NoDocuments = props => (
  <div className="row no-gutters">
    <div className="col-lg-12">
      <div className="card text-center justify-content-center align-items-center min-h-500 ">
        <button className="circle-bg-width-80 circle-bg circle-bg-gray">
          <img
            src={require('../assets/empty-fee.svg')}
            className="svg"
            alt="Min Unit"
          />
        </button>
        <div className="not-found">
          {/* <div className="status-code"> 404 </div> */}
          <div className="status-text">{props.message}</div>
          <Link
            className="btn btn-primary btn-primary-color btn-remove-p-r w-100 mt-5"
            to="/"
          >
            Dashboard
          </Link>
        </div>
      </div>
      {/* card for outstanding fees */}
    </div>
  </div>
);
